import React, { useState } from 'react';
import { 
  FiBarChart2, 
  FiMessageSquare, 
  FiFolder, 
  FiSearch, 
  FiFilter,
  FiRefreshCw,
  FiLock,
  FiEye,
  FiStar,
  FiUser,
  FiCalendar,
  FiChevronRight,
  FiMapPin
} from 'react-icons/fi';
import './DiscussionList.css';
import GeminiChat from '../GeminiChat';

const DiscussionList = ({ 
  discussions, 
  categories, 
  onSelectDiscussion, 
  onCreateDiscussion 
}) => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('newest');
  const [searchTerm, setSearchTerm] = useState('');

  const safeDiscussions = discussions || [];
  const safeCategories = categories || [];

  // Fonction pour utiliser la réponse de l'IA (si nécessaire)
  const handleUseAIResponse = (aiResponse) => {
    // Si vous voulez utiliser l'IA dans la liste, vous pouvez implémenter cette fonction
    console.log('Réponse IA reçue:', aiResponse);
  };

  const filteredDiscussions = safeDiscussions
    .filter(discussion => 
      selectedCategory === 'all' || discussion.category_id?.toString() === selectedCategory
    )
    .filter(discussion =>
      discussion.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      discussion.content?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          return new Date(b.created_at || 0) - new Date(a.created_at || 0);
        case 'oldest':
          return new Date(a.created_at || 0) - new Date(b.created_at || 0);
        case 'mostViewed':
          return (b.views || 0) - (a.views || 0);
        case 'mostReplies':
          return (b.replies_count || 0) - (a.replies_count || 0);
        default:
          return 0;
      }
    });

  return (
    <div className="discussion-list">
      {/* En-tête avec statistiques */}
      <div className="list-header">
        <div className="header-content">
          <div className="header-stats">
            <div className="stat-card">
              <div className="stat-icon">
                <FiBarChart2 />
              </div>
              <div className="stat-info">
                <span className="stat-number">{safeDiscussions.length}</span>
                <span className="stat-label">Discussions</span>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <FiMessageSquare />
              </div>
              <div className="stat-info">
                <span className="stat-number">
                  {safeDiscussions.reduce((acc, curr) => acc + (curr.replies_count || 0), 0)}
                </span>
                <span className="stat-label">Réponses</span>
              </div>
            </div>
          </div>
        </div>
      </div>

 {/* Filtres et recherche */}
<div className="dl-filters-section">
  <div className="dl-filters-wrapper">
    <div className="dl-filters-row">
      <div className="dl-filter-field">
        <label className="dl-filter-label">
          <FiFolder className="dl-filter-icon" />
          Catégorie
        </label>
        <select 
          value={selectedCategory} 
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="dl-filter-select"
        >
          <option value="all">Toutes les catégories</option>
          {safeCategories.map(category => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
      </div>

      <div className="dl-filter-field">
        <label className="dl-filter-label">
          <FiSearch className="dl-filter-icon" />
          Rechercher
        </label>
        <div className="dl-search-wrapper">
          <FiSearch className="dl-search-icon" />
          <input
            type="text"
            placeholder="Rechercher une discussion..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="dl-search-field"
          />
        </div>
      </div>
    </div>

    <div className="dl-filters-row">
      <div className="dl-filter-field">
        <label className="dl-filter-label">
          <FiFilter className="dl-filter-icon" />
          Trier par
        </label>
        <select 
          value={sortBy} 
          onChange={(e) => setSortBy(e.target.value)}
          className="dl-filter-select"
        >
          <option value="newest">Plus récent</option>
          <option value="oldest">Plus ancien</option>
          <option value="mostViewed">Plus vus</option>
          <option value="mostReplies">Plus de réponses</option>
        </select>
      </div>

      <div className="dl-filter-actions">
        <button 
          className="dl-filter-reset-btn"
          onClick={() => {
            setSelectedCategory('all');
            setSearchTerm('');
            setSortBy('newest');
          }}
        >
          <FiRefreshCw className="dl-reset-icon" />
          Réinitialiser
        </button>
      </div>
    </div>
  </div>
</div>

      {/* Résultats */}
      <div className="results-info">
        <div className="results-content">
          <span className="results-count">
            {filteredDiscussions.length} discussion{filteredDiscussions.length !== 1 ? 's' : ''} trouvée{filteredDiscussions.length !== 1 ? 's' : ''}
          </span>
          {(searchTerm || selectedCategory !== 'all') && (
            <div className="active-filters">
              {searchTerm && (
                <span className="filter-tag">
                  Recherche : "{searchTerm}"
                </span>
              )}
              {selectedCategory !== 'all' && (
                <span className="filter-tag">
                  Catégorie : {safeCategories.find(c => c.id.toString() === selectedCategory)?.name}
                </span>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Liste des discussions */}
      <div className="discussions-container">
        {filteredDiscussions.length === 0 ? (
          <div className="no-discussions">
            <div className="no-discussions-icon">
              <FiMessageSquare />
            </div>
            <h3>Aucune discussion trouvée</h3>
            <p>
              {searchTerm || selectedCategory !== 'all' 
                ? 'Aucune discussion ne correspond à vos critères de recherche.'
                : 'Soyez le premier à démarrer une discussion !'
              }
            </p>
            {(searchTerm || selectedCategory !== 'all') && (
              <button 
                className="btn-clear-filters"
                onClick={() => {
                  setSelectedCategory('all');
                  setSearchTerm('');
                }}
              >
                Effacer les filtres
              </button>
            )}
          </div>
        ) : (
          filteredDiscussions.map((discussion, index) => (
            <div 
              key={discussion.id} 
              className={`discussion-item ${discussion.is_pinned ? 'pinned' : ''} ${discussion.is_locked ? 'locked' : ''}`}
              onClick={() => onSelectDiscussion && onSelectDiscussion(discussion.id)}
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="discussion-main">
                <div className="discussion-header">
                  <div className="discussion-title-section">
                    <h3 className="discussion-title">
                      {discussion.title || 'Sans titre'}
                    </h3>
                    <div className="discussion-badges">
                      {discussion.is_pinned && (
                        <span className="status-badge pinned-badge">
                          <FiMapPin className="badge-icon" />
                          Épinglé
                        </span>
                      )}
                      {discussion.is_locked && (
                        <span className="status-badge locked-badge">
                          <FiLock className="badge-icon" />
                          Verrouillé
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="discussion-actions">
                    <span className="discussion-time">
                      <FiCalendar className="time-icon" />
                      {new Date(discussion.created_at || Date.now()).toLocaleDateString('fr-FR', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </span>
                    <FiChevronRight className="chevron-icon" />
                  </div>
                </div>
                
                <p className="discussion-excerpt">
                  {discussion.content?.substring(0, 150) || 'Aucun contenu'}...
                </p>
                
                <div className="discussion-footer">
                  <div className="discussion-meta">
                    <span className="category-badge">
                      {safeCategories.find(c => c.id === discussion.category_id)?.name || 'Non catégorisé'}
                    </span>
                    <span className="author">
                      <FiUser className="author-avatar" />
                      Par {discussion.author?.name || 'Utilisateur'}
                    </span>
                  </div>
                  
                  <div className="discussion-stats">
                    <div className="statstats">
                      <FiEye className="stat-iconstats" />
                      <span className="stat-numberstats">{discussion.views || 0}</span>
                    </div>
                    <div className="statstats">
                      <FiMessageSquare className="stat-iconstats" />
                      <span className="stat-numberstats">{discussion.replies_count || 0}</span>
                    </div>
                    <div className="statstats">
                      <FiStar className="stat-iconstats" />
                      <span className="stat-numberstats">{discussion.likes_count || 0}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Assistant IA - Version simplifiée pour la liste */}
      <GeminiChat 
        onUseResponse={handleUseAIResponse}
        context="Je cherche de l'aide pour naviguer dans les discussions ou poser des questions générales."
      />
    </div>
  );
};

export default DiscussionList;